import * as React from 'react';

/*
 * TopBar — minimal identity bar (v2 design system).
 * Left: org circle (avatar + switcher) and the context switcher (section
 * at app level, job at event level). Right slot: account avatar.
 * Sticky, blurred, borderless. The slots are composed by V2Shell.
 */

interface TopBarProps {
    left: React.ReactNode;
    right?: React.ReactNode;
}

export default function TopBar({ left, right }: TopBarProps) {
    return (
        <header className="sticky top-0 z-20 bg-background/80 py-3.5 backdrop-blur-[10px]">
            <div className="mx-auto flex w-full max-w-[1060px] items-center justify-between px-[clamp(18px,3vw,34px)]">
                <div className="flex items-center gap-3.5">{left}</div>
                <div className="flex items-center gap-4">{right}</div>
            </div>
        </header>
    );
}
